// Preserva la campaña de entrada (utm_*) mientras el visitante decide sobre las cookies.
//
// El problema que resuelve: GA4 y el Pixel están bloqueados hasta que se acepta el
// banner. Si el visitante llega con `?utm_campaign=bio_facunfit`, tarda unos segundos
// en aceptar y mientras tanto navega a otra ruta, el primer page_view se envía con la
// URL nueva —ya sin utm_*— y GA4 clasifica la sesión como tráfico directo. La campaña
// se pierde justo en el caso que más interesa medir.
//
// Aquí se captura la ruta de entrada en cuanto carga el módulo y se guarda SOLO EN
// MEMORIA (una variable de módulo). No se escribe nada en localStorage, sessionStorage
// ni cookies, así que no hay tratamiento que requiera consentimiento previo: si el
// visitante rechaza, el dato muere con la pestaña sin haber salido del navegador.

const CAMPAIGN_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
];

let landingPath = null;
let landingHasCampaign = false;
let consumed = false;

if (typeof window !== 'undefined') {
  landingPath = window.location.pathname + window.location.search;

  const params = new URLSearchParams(window.location.search);
  landingHasCampaign = CAMPAIGN_KEYS.some((key) => params.has(key));
}

export const hasCampaignParams = () => landingHasCampaign;

export const getLandingPath = () => landingPath;

// Devuelve la ruta de entrada con sus utm_* una única vez, para el primer page_view
// que se llegue a enviar de verdad. Devuelve null si no había campaña o si ya se usó,
// y entonces quien llama debe seguir con la ruta actual.
export const consumeLandingPath = () => {
  if (consumed || !landingHasCampaign) return null;

  consumed = true;
  return landingPath;
};
